import gql from 'graphql-tag';

export const submitCheckupInterview = gql`
  mutation submitCheckupInterview($input: SubmitCheckupInterviewInput!) {
    submitCheckupInterview(input: $input) {
      id
    }
  }
`;
